// States
import Vue from "vue";
import {apiModel, makeApiRequest} from "../../../api";
import Swal from "sweetalert2";
import router from "../../../router/router";

const state = {

};

// Getters
const getters = {

};

// Actions
const actions = {
    emailHandler(context, payload) {
        function successCallback(response) {
            Swal.fire({
                    icon: 'success',
                    title:'Lien de modification de mot de passe envoyé',
                    text:'Consultez vos mails pour accéder au lien de modification de mot de passe',
                    timer: 2500,
                }
            );
        }

        function errorCallback(error) {
            Vue.swal(
                error.message,
                '',
                'error'
            );
        }

        const localToken = "";

        makeApiRequest(payload.args, apiModel.Auth.Email, localToken, successCallback, errorCallback);
    },

    resetSmsPassword(context, payload) {
        function successCallback(response) {
            Swal.fire({
                    icon: 'success',
                    title:'Reinitialisation de mot de passe',
                    text:'Consultez vos sms pour accéder au mot de passe temporaire généré',
                    timer: 2500,
                }
            );
        }

        function errorCallback(error) {
            Vue.swal(
                error.message,
                '',
                'error'
            );
        }

        const localToken = "";

        makeApiRequest(payload.args, apiModel.Auth.SmsReset, localToken, successCallback, errorCallback);
    },
    resetSecretQuestion(context, payload) {
        function successCallback(response) {
            Swal.fire({
                    icon: 'success',
                    title:'Question sécrete',
                    text:'Votre question sécrète à été mis à jour avec succès',
                    timer: 2500,
                }
            );
        }

        function errorCallback(error) {
            Vue.swal(
                error.message,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Auth.SecretReset, localToken, successCallback, errorCallback);
    },

    resetHandler(context, payload) {
        function successCallback(response) {
            Swal.fire({
                    icon: 'success',
                    title:'Mot de passe modifié avec succes',
                    text:'',
                    timer: 2500,
                }
            );

            // Redirect to login view
            router.push("/login");
        }

        function errorCallback(error) {
            Vue.swal(
                error.message,
                '',
                'error'
            );
        }

        const localToken = "";

        makeApiRequest(payload.args, apiModel.Auth.Reset, localToken, successCallback, errorCallback);
    },

    updatePassword(context, payload) {
        function successCallback(response) {
            Swal.fire({
                    icon: 'success',
                    title:'Mot de passe modifié avec succes',
                    text:'',
                    timer: 2500,
                }
            );

            // Redirect to login view
            // router.push("/login");
        }

        function errorCallback(error) {
            Vue.swal(
                error.message,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Auth.UpdatePassword, localToken, successCallback, errorCallback);
    },

};

// Mutations
const mutations = {

};


export default {
    state,
    getters,
    actions,
    mutations
}